import apiClient from './apiClient';
import type {
  PSDData,
  PSDGeneral,
  PSDSieveDetail,
  PSDHydroDetail,
} from '../types/psd';

export const getPsdData = async (workOrderDetailKey: string): Promise<PSDData> => {
  const r = await apiClient.get<PSDData>(`/workorderdetails/${workOrderDetailKey}/psd`);
  return r.data;
};

export const savePsdData = async (
  workOrderDetailKey: string,
  general: PSDGeneral,
  sieveDetails: PSDSieveDetail[],
  hydroDetails: PSDHydroDetail[],
  confirmReset = false,
): Promise<PSDData & { resetPerformed?: boolean }> => {
  const r = await apiClient.put(`/workorderdetails/${workOrderDetailKey}/psd`, {
    general,
    sieveDetails,
    hydroDetails,
    confirmReset,
  });
  return r.data;
};
